import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { MapPin, Compass } from "@phosphor-icons/react";

export default function JobMap({ jobId, postcode, location }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    let cancel = false;
    api.get(`/jobs/${jobId}/distance`).then((r) => { if (!cancel) setD(r.data); }).catch(() => setErr(true));
    return () => { cancel = true; };
  }, [jobId]);

  const jobGeo = d?.job;
  const embed = jobGeo
    ? `https://www.openstreetmap.org/export/embed.html?bbox=${jobGeo.lon-0.02}%2C${jobGeo.lat-0.015}%2C${jobGeo.lon+0.02}%2C${jobGeo.lat+0.015}&layer=mapnik&marker=${jobGeo.lat}%2C${jobGeo.lon}`
    : null;

  return (
    <div className="card-tactile overflow-hidden">
      <div className="px-4 py-3 border-b border-slate-200 flex items-center justify-between">
        <div className="flex items-center gap-2"><MapPin size={18} className="text-blue-600"/><span className="font-semibold text-slate-900">{location}</span></div>
        {d?.distance_miles != null && (
          <div className="flex items-center gap-1.5 text-sm font-semibold text-slate-700" data-testid="job-distance">
            <Compass size={14} /> {d.distance_miles} mi away
          </div>
        )}
      </div>
      <div className="aspect-video bg-slate-100 relative">
        {embed ? (
          <iframe title="map" src={embed} className="absolute inset-0 w-full h-full border-0" data-testid="job-map-iframe" />
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-slate-500 text-sm">
            {err || (d && !d.job) ? "Add a postcode to see the map." : "Loading map…"}
          </div>
        )}
      </div>
      {d?.distance_km != null && (
        <div className="px-4 py-2 border-t border-slate-200 text-xs text-slate-500">Straight-line distance from your saved postcode.</div>
      )}
    </div>
  );
}
